import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
    isBetaSeller: false
}

export {
  state,
  getters,
  mutations,
  actions
}
  